/**
 * @brandOverride ANCom
 */

import { init as productAddToCartInit } from './productAddToCartComponent';
import { init as productControlsInit } from './productControlsComponent';
import { init as productBackInStockInit } from './productBackInStockComponent';
import { init as productRightRailInit } from './productRightRailComponent';
import { init as productGiftCardInit } from './productGiftCardComponent';
import { init as productDetailsInit } from './productDetailsComponent';
import { init as productImageViewerInit } from './productImageViewerComponent';
import { init as productMessagesInit } from './productMessagesComponent';
import { init as productListMessagesInit } from './productListMessagesComponent';
import { init as productMetaInit } from './productMetaComponent';
import { init as productMetaPriceInit } from './productMetaPriceComponent';
import { init as productReviewsInit } from './productReviewsComponent';
import { init as productSocialInit } from './productSocialComponent';
import { init as productUgcInit } from './productUgcComponent';
import { init as productWishListInit } from './productWishListComponent';
import { init as productWishListMultipleInit } from './productWishListMultipleComponent';
import { init as productShopTheLookInit } from './productShopTheLookComponent';
import { init as productShopTheSetInit } from './productShopTheSetComponent';
import { init as productFavoritesInit } from './productFavoritesComponent';
import { init as productYmalRRComponentInit } from './productYmalRRComponent';
import { init as backToCatalogComponentInit } from './backToCatalogComponent';
import { init as rrInit } from '../../../core/js/components/richRelevanceComponent';
import { init as marketplaceMetaInit } from './marketplaceMetaComponent';

import { productComponentConfigOverride } from './productComponentConfigOverride';

import { generate, mergeConfigOverrides } from '../../../core/js/utils/componentUtils';
import { getDefaultOptions } from '../../../core/js/utils/a15componentUtils';
import { getTargetedProduct } from '../utils/productComponentUtils';
import { scrollToElement } from '../../../core/js/utils/scrollUtils';
import { getQueryParams } from '../../../core/js/utils/routerUtils';
import {
    getTargetedProduct as getTargetedProductObj,
    setSalesAttributes
} from '../utils/utils';

import { isNotSoldOut } from '../utils/soldOutUtils';

import {
    shouldDisplayPdpUgc,
    getUgcConfigsForPdp,
    init as ugcComponentInit
} from '../../../core/js/components/ugcComponent';

import { getRROverrides } from './richRelevanceComponentOverrides';
import { getDYPlacementIdFromSettings } from '../../../core/js/utils/rrUtils';

import productControlsFaceoutTemplate from 'controls/product-controls-faceout.j2';
import alsoBoughtWithTemplate from 'product-also-bought-with.j2';
import visuallySimilarTemplate from 'product-visually-similar.j2';

function simpleSoldOut(store) {
    return isNotSoldOut(store.getState());
}

function complexSoldOut(store) {
    return !store.getState().product.productUnavailable;
}

function isProductGiftCardAndNotSoldOut(store) {
    const product = getTargetedProductObj(store.getState());

    return (product.product.isEgiftCard || product.product.isGiftCard) && isNotSoldOut(store.getState());
}

const complexSoldOutOverides = {
    isComponentValid: complexSoldOut
};

const giftCardComponentOverides = {
    isComponentValid: isProductGiftCardAndNotSoldOut
};

export function generateDictionary() {
    return this.multiple ? this.multiple[this.multipleIndex] : {};
}

export function attachEvents(store) {
    $(document).on(this.scopedEvent('click'), '.js-shop-the-set', (e) => {
        e.preventDefault();
        scrollToElement($('.js-product-shop-the-set'));
    });

    $(document).on(this.scopedEvent('click'), '.js-product-reviews-link', (e) => {
        e.preventDefault();
        scrollToElement($('.js-product-reviews'));
    });
}

function determineRRPlacement(store) {
    // set rrPlacement component property according to value of productPrimary RR placement id in the Tornado settings
    const state = store.getState();

    const alsoBoughtWithPlacement = getDYPlacementIdFromSettings(state, 'productAlsoBoughtWith');

    if (alsoBoughtWithPlacement) {
        this.rrPlacement = alsoBoughtWithPlacement;
    }
}

function afterConstruction(store) {
    const state = store.getState();
    const slug = _.get(state, 'product.productSlug', '');
    const salesAttributes = getQueryParams(window.location.href)['sales-attributes'];

    if (salesAttributes) {
        setSalesAttributes(slug, salesAttributes);
    }
}

export function init(store, overrides = {}) {
    const state = store.getState();
    const curalateUrl = _.get(state, 'core.constants.thirdParty.default.curalate.photo_upload_endpoint_mobile');
    const href = window.location.href.split('#')[0];
    const shareYourPicsLink = `${curalateUrl}?locale=${state.core.language}&source=${href}`;
    const rrOverrides = getRROverrides(state) || {};
    const placementKey = _.get(
        state,
        'core.constants.thirdParty.default.dynamic_yield.placement_ids.productAlsoBoughtWith',
        'pdp2'
    );
    const visuallySimilarPlacementKey = _.get(state,
        'core.constants.thirdParty.default.dynamic_yield.placement_ids.productVisuallySimilar',
        'pdp3'
    );

    const config = {
        targetedProduct: 'product',
        getTargetedProduct: getTargetedProduct,
        inheritedOverrides: ['targetedProduct', 'getTargetedProduct'],
        children: [
            backToCatalogComponentInit,
            [productAddToCartInit, complexSoldOutOverides],
            [productControlsInit, {
                isComponentValid: simpleSoldOut,
                template: productControlsFaceoutTemplate
            }],
            [productBackInStockInit],
            [productRightRailInit],
            [productGiftCardInit, giftCardComponentOverides],
            [productDetailsInit, complexSoldOutOverides],
            [productImageViewerInit, complexSoldOutOverides],
            [productMessagesInit, complexSoldOutOverides],
            [productListMessagesInit, complexSoldOutOverides],
            [productMetaInit, complexSoldOutOverides],
            [productMetaPriceInit, complexSoldOutOverides],
            [marketplaceMetaInit, complexSoldOutOverides],
            [productReviewsInit, complexSoldOutOverides],
            [productShopTheLookInit, complexSoldOutOverides],
            [productShopTheSetInit, complexSoldOutOverides],
            [productSocialInit, complexSoldOutOverides],
            [productUgcInit, complexSoldOutOverides],
            [productWishListInit, complexSoldOutOverides],
            [productWishListMultipleInit, complexSoldOutOverides],
            [productFavoritesInit, complexSoldOutOverides],
            productYmalRRComponentInit,
            [rrInit, {
                templateLocation: '.dom-product-also-bought-with',
                template: alsoBoughtWithTemplate,
                name: 'alsoBoughtWithComponent',
                watch: [`core.rrRecs.${placementKey}.recs`, 'core.deviceCharacteristics'],
                beforeConstruction: determineRRPlacement,
                generateDictionary: rrOverrides.generateDictionary
            }],
            [rrInit, {
                templateLocation: '.dom-product-visually-similar',
                template: visuallySimilarTemplate,
                name: 'visuallySimilarComponent',
                rrPlacement: visuallySimilarPlacementKey,
                watch: [`core.rrRecs.${visuallySimilarPlacementKey}.recs`, 'core.deviceCharacteristics'],
                generateDictionary: rrOverrides.generateDictionary
            }],
            [ugcComponentInit, {
                isComponentValid: shouldDisplayPdpUgc,
                getUgcConfigs: getUgcConfigsForPdp,
                feature: 'product',
                shareYourPicsLink: shareYourPicsLink,
                carouselMultiWatch: (index) => `core.ugc.${index}`,
                multiple: null,
                lazyLoad: true,
                loader: {
                    inlineStyles: 'position: relative; top: 50px;'
                }
            }]
        ],
        name: 'productComponent',
        generateDictionary: generateDictionary,
        attachEvents: attachEvents,
        afterConstruction: afterConstruction
    };

    const overridenConfig = mergeConfigOverrides(config, productComponentConfigOverride);

    return generate(overridenConfig, store, overrides, getDefaultOptions(store));
}
